import { createContext, useState } from "react";

export const WalletFocusContext = createContext();

export function WalletFocusProvider({ children }) {
  const [highlightWallet, setHighlightWallet] = useState(false);

  return (
    <WalletFocusContext.Provider value={{ highlightWallet, setHighlightWallet }}>
      {children}
    </WalletFocusContext.Provider>
  );
}
